module.exports = __webpack_public_path__ + "mo/img/piece-03.67564464.svg";